module.exports = __webpack_public_path__ + "static/media/SmilesWeding-01.ca208ef2.jpg";